<div>
    <p-dialog
        [header]="header"
        [(visible)]="sidebarVisible"
        [modal]="true"
        (onHide)="onCloseSidebar()"
        [style]="{ width: '80vw', 'max-height': '80vh', 'overflow-x': 'hidden' }"
        [draggable]="false"
        [resizable]="false"
    >
        <ng-template pTemplate="header">
            <div
                class="flex justify-content-between align-items-center headerContainer"
            >
                <h3 class="px-5">{{ header }} - {{ documentName }}</h3>
                <div>
                    <button
                        type="button"
                        class="mr-3 cursor"
                        (click)="copyText()"
                        aria-label="Copy summary"
                        *ngIf="!iscopyingSummary"
                    >
                        <i class="bi bi-clipboard mr-1"></i>
                    </button>
                    <span class="mr-3" *ngIf="iscopyingSummary"
                        ><i class="bi bi-check2 mr-1"></i>
                    </span>
                    <button
                        type="button"
                        class="mr-3 cursor"
                        *ngIf="!downloadSummary"
                        (click)="downloadPdfFile()"
                        aria-label="Download summary PDF"
                    >
                        <i class="bi bi-download mr-1"></i>
                    </button>
                     <span class="mr-3" *ngIf="downloadSummary"
                        ><i  class="pi pi-spin pi-spinner mr-1  "> </i>
                    </span>

                </div>
            </div>
        </ng-template>
        
        <div #documentText>
            <div *ngFor="let summary of summaryDataSplit; let i = index">
                <span *ngIf="i !== 0"><br /></span>
                <div
                    *ngFor="let text of summary.split('\n\n'); let idx = index"
                >
                    <span *ngIf="idx !== 0"><br /></span>
                    <div
                        class="px-5"
                        [ngClass]="
                            idx === 0 &&
                            summary.split('\n\n').length > 1 &&
                            longSummaryType === summaryTypeCIM
                                ? 'headers'
                                : 'content'
                        "
                        [innerText]="text"
                    ></div>
                </div>
            </div>
        </div>
    </p-dialog>
</div>